import { IBufferOptions } from "@ai360/core";
import { MAP_STATE_KEY } from "../../selectors";
export const MAP_TOOLS_STATE_KEY = "MAP_TOOLS_STATE";

const _mapTools = (state) => state[MAP_STATE_KEY][MAP_TOOLS_STATE_KEY];

export const getActiveMapTool = (state: unknown): any => _mapTools(state).activeMapTool;

export const getActiveToolset = (state: unknown): any => _mapTools(state).activeToolset;

export const getActiveType = (state: unknown): any => _mapTools(state).activeType;

export const getAreaUnits = (state: unknown): any => _mapTools(state).areaUnits;

export const getBatchReset = (state: unknown): any => _mapTools(state).batchReset;

export const getBufferOptions = (state: unknown): IBufferOptions => _mapTools(state).bufferOptions;

export const getBufferReady = (state: unknown): boolean => _mapTools(state).bufferReady;

export const getChosePortalBoundary = (state: unknown): any => _mapTools(state).chosePortalBoundary;

export const getCurrentProcessCounts = (state: unknown): any =>
    _mapTools(state).currentProcessCounts;

export const getDrawToolFlags = (state: unknown): any => _mapTools(state).drawToolFlags;

export const getFieldEditGeometries = (state: unknown): any =>
    _mapTools(state).currentFieldEdits.geometries;

export const getJdFallbackFieldEditGeometries = (state: unknown): any =>
    _mapTools(state).jdFallbackFieldEditGeometries;

export const getFieldEditsChanged = (state: unknown): any =>
    _mapTools(state).currentFieldEdits.changed;

export const getFieldEditsLoaded = (state: unknown): any =>
    _mapTools(state).currentFieldEdits.loaded;

export const getGeneratedShrinkwrappedBoundary = (state: unknown): any =>
    _mapTools(state).generatedShrinkwrappedBoundary;

export const getGridRemoveFlag = (state: unknown): any => _mapTools(state).gridRemoveFlag;

export const getIsZoneGridModalOpen = (state: unknown): any => _mapTools(state).isZoneGridModalOpen;

export const getLengthUnits = (state: unknown): any => _mapTools(state).lengthUnits;

export const getToolsProcessing = (state: unknown): any => _mapTools(state).isProcessing;

export const getToolsetDisabled = (state: unknown): any => _mapTools(state).toolsetDisabled;

export const getToolsetPayload = (state: unknown): any => _mapTools(state).toolsetPayload;

export const getTraceApplyFlag = (state: unknown): any => _mapTools(state).traceFlags.apply;

export const getTraceResetFlag = (state: unknown): any => _mapTools(state).traceFlags.reset;

export const getUserJdPortalAccess = (state: unknown): any =>
    _mapTools(state).userHasJdPortalAccess;

export const getVisibleToolbarMenuDimensions = (state: unknown): any =>
    _mapTools(state).visibleToolbarMenuDimensions;

export const getZoneEliminateOptions = (state: unknown): any =>
    _mapTools(state).zoneEliminateOptions;

export const defaultZoneUserGridSettings = (state: unknown): any =>
    _mapTools(state).defaultZoneUserGridSettings;

export const getZoneGridOrientationSettings = (state: unknown): any =>
    _mapTools(state).zoneGridOrientationSettings;

export const getZoneGridStandardUnitSettings = (state: unknown): any =>
    _mapTools(state).zoneGridStandardUnitSettings;

export const getZoneGridOptions = (state: unknown): any => _mapTools(state).zoneGridOptions;
